export default __webpack_public_path__ + "static/media/Australia.63232adf.jpg";